import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { authApi, formatApiError } from "../lib/auth";
import { KeyRound, MailCheck, Loader2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await authApi.requestPasswordReset(email.trim());
    } catch (err) {
      // Intentionally swallow — never reveal whether the email exists.
      console.error("forgot-password request error:", formatApiError(err));
    } finally {
      setBusy(false);
      // Always show the confirmation regardless of success or failure.
      setSubmitted(true);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 bg-gradient-to-br from-slate-50 to-slate-200"
      data-testid="forgot-page"
    >
      <Card className="w-full max-w-md shadow-lg">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-xl">
            <KeyRound className="h-5 w-5" /> Reset your password
          </CardTitle>
          <p className="text-sm text-slate-500">ZAMBA Product Selector</p>
        </CardHeader>
        <CardContent>
          {submitted ? (
            <div className="space-y-4" data-testid="forgot-confirmation">
              <div className="flex items-start gap-3 bg-emerald-50 border border-emerald-200 text-emerald-900 rounded p-3 text-sm">
                <MailCheck className="h-4 w-4 mt-0.5 flex-none" />
                <span>
                  If an account exists for that email, a reset link has been sent.
                  Check your inbox.
                </span>
              </div>
              <div className="text-center text-sm text-slate-600">
                Remember your password?{" "}
                <Link to="/login" className="text-slate-900 underline">
                  Sign in
                </Link>
              </div>
            </div>
          ) : (
            <form onSubmit={onSubmit} className="space-y-4">
              <div>
                <Label htmlFor="forgot-email">Email</Label>
                <Input
                  id="forgot-email"
                  type="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid="forgot-email-input"
                  placeholder="you@yourcompany.com"
                />
              </div>
              <Button
                type="submit"
                disabled={busy}
                className="w-full bg-primary text-primary-foreground hover:bg-primary/90"
                data-testid="forgot-submit-btn"
              >
                {busy ? (
                  <>
                    <Loader2 className="h-4 w-4 mr-2 animate-spin" />
                    Sending…
                  </>
                ) : (
                  "Send reset link"
                )}
              </Button>
              <div className="text-center text-sm text-slate-600">
                Remember your password?{" "}
                <Link to="/login" className="text-slate-900 underline">
                  Sign in
                </Link>
              </div>
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
